export default __webpack_public_path__ + "static/media/work_web-md@1x.5a796ade.webp";